import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: '¿Esto funciona si soy agente nuevo o solo para agentes experimentados?',
  a: 'El Sistema A.C.E.™ funciona para ambos perfiles. Para agentes nuevos, construimos tu marca desde cero y te posicionamos como experto local desde el primer mes. Para agentes experimentados, potenciamos lo que ya tienes y reactivamos tu base de datos dormida.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'Los primeros leads calificados llegan entre la semana 2 y 4 de implementación. Las primeras transacciones cerradas típicamente ocurren entre los 30 y 90 días. Depende de tu zona y tu velocidad de seguimiento.'
}, {
  q: '¿Los leads son exclusivos para mí o los comparten con otros agentes?',
  a: '100% exclusivos. A diferencia de Zillow o Realtor.com, los leads que generamos son solo para ti en tu zona de servicio. No los vendemos a ningún otro agente. Cuando tomamos tu zona, la bloqueamos.'
}, {
  q: '¿Qué pasa si ya tengo un equipo de marketing?',
  a: 'Trabajamos en paralelo o reemplazamos lo que no está funcionando. Hacemos un diagnóstico de tu situación actual y te decimos exactamente qué está fallando y cómo lo corregimos. Sin rodeos.'
}, {
  q: '¿Cuánto cuesta el Sistema A.C.E.™?',
  a: 'El costo depende de tu zona, volumen objetivo y las fases que implementemos. Por eso hacemos una sesión estratégica gratuita primero — para darte un número exacto basado en tu mercado específico, no un precio genérico de catálogo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 md:py-32 px-5 md:px-8 bg-carbon" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 md:mb-16 border-l-4 border-gold pl-5 md:pl-6" data-id="element-115">
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase" data-id="element-116">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-117">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-30px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} className={`border-l-2 transition-all duration-300 ${isOpen ? 'border-gold bg-dark-200/30' : 'border-transparent hover:bg-dark-200/10'}`} data-id="element-118">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between px-6 py-6 md:py-8 text-left gap-6 group" data-id="element-119">
                  <span className={`font-bold text-base md:text-lg leading-snug transition-colors ${isOpen ? 'text-gold' : 'text-white group-hover:text-gray-200'}`} data-id="element-120">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="shrink-0" data-id="element-121">
                    <ChevronDownIcon className={`w-6 h-6 ${isOpen ? 'text-gold' : 'text-gray-500'}`} data-id="element-122" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-123">
                  {isOpen && <motion.div key="content" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-124">
                      <p className="text-gray-400 text-base md:text-lg leading-relaxed px-6 pb-8" data-id="element-125">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}